import { FC } from 'react'
import { Switch, Route } from 'react-router-dom'
import routes from '../routes';
import Dashboard from '../Components/Dashboard';
import { verifyUserAccess } from '../Utils/auth-utils';
import { consolelog } from '../Utils/consolelog';

const Routes: FC<any> = (authContext) => {
    return (
        <>
            <Switch>
                {
                    routes.map(({ path, loader, component,hasLinkAccess,name }) => (
                        verifyUserAccess(name).hasScreenAccess && <Route exact key={path} path={path} component={component} />
                    ))
                }
                <Route component={Dashboard} />
            </Switch>
        </>
    )
}

export default Routes;